<template>
  <div>
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="bidData === undefined">
      <h4 class="alert-heading">Erreur de récupération des données de l'Offre</h4>
      <div class="alert-body">
       Pas d'offre trouvé sur cet identifiant. Vérifiez
        <b-link class="alert-link" :to="{ name: 'apps-bids-list' }">
          la liste des Offres
        </b-link>
        pour d'autres Offres.
      </div>
    </b-alert>

    <template v-if="bidData">
      <!-- First Row -->
      <b-row>
        <b-col cols="12" xl="9" lg="8" md="7">
          <bid-view-bid-info-card :bid-data="bidData" @stateUpdated="bidUpdated" />
        </b-col>
        <b-col cols="12" md="5" xl="3" lg="4">
          <bid-view-bid-plan-card @bidUpdated="bidUpdated = true" :bid-data="bidData" />
        </b-col>
      </b-row>

      <!-- <invoice-list /> -->
      <expense-list v-if="$can('read_bid', 'Offres')" :opportunityId="bidId" opportunityType="bids" :updated.sync="bidUpdated" @expenseUpdated="bidUpdated = true" />
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted, computed } from "@vue/composition-api";
import { BRow, BCol, BAlert, BLink } from "bootstrap-vue";
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import BidViewBidInfoCard from "./BidViewBidInfoCard.vue";
import BidViewBidPlanCard from "./BidViewBidPlanCard.vue";
import ExpenseList from '@/components/expenses/ExpenseList.vue';

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,

    // Local Components
    BidViewBidInfoCard,
    BidViewBidPlanCard,

    InvoiceList,
    ExpenseList,
  },
  setup() {
    const bidData = ref(null);
    const bidUpdated = ref(false);
    const bidId = computed(() => router.currentRoute.params.id )

    store
      .dispatch("bid/fetchBid", { id: bidId.value })
      .then((response) => {
        bidData.value = response;
      })
      .catch((error) => {
          bidData.value = undefined;
      });

    return {
      bidData,
      bidUpdated,
      bidId,
    };
  },
};
</script>
